export const css = {
    root: '_3AJLLTed',
    main: 'JQSA6KkE',
    underlayVisible: '_1UOuOlpK',
    title: '_2ikv3JS4',
    content: '_34ZnrZxt',
    close: 'jzTjA0Lg',
    closeIcon: 'OEKlMbem',
    actions: '_29cgr3_6',
    ' _key': 'afcpe-theme/dojo/dialog'
};
export default css;
